import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import {  deleteNewHireContactRoute } from '../api/constants';
import { newHireContactList } from '../constants';

type useDeleteNewHireContactProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useDeleteNewHireContact = ({
    setErrorText,
}: useDeleteNewHireContactProps) => {
    const client = useQueryClient();
    const { mutate: deletenewHireContact, isLoading: isDeletingnewHireContact } =
        useMutation({
            mutationFn: (variables: {
                id: number;
                company_id?: number;
            }) =>
                axiosInstance
                    .post(deleteNewHireContactRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([newHireContactList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        deletenewHireContact,
        isDeletingnewHireContact,
    };
};
